import { Abcd } from './icons/abcd';
import { Activity } from './icons/activity';
import { Animals } from './icons/animals';
import { ApplePay } from './icons/apple-pay';
import { Archive } from './icons/archive';
import { ArrowDown } from './icons/arrow-down';
import { ArrowExtend } from './icons/arrow-extend';
import { ArrowLeft } from './icons/arrow-left';
import { ArrowMinimize } from './icons/arrow-minimize';
import { ArrowRight } from './icons/arrow-right';
import { ArrowShuffle } from './icons/arrow-shuffle';
import { ArrowUp } from './icons/arrow-up';
import { ArrowUpDown } from './icons/arrow-up-down';
import { AssistanceServices } from './icons/assistance-services';
import { Baby } from './icons/baby';
import { BagWithGift } from './icons/bag-with-gift';
import { Bank } from './icons/bank';
import { Barcode } from './icons/barcode';
import { BeachUmbrella } from './icons/beach-umbrella';
import { Bell } from './icons/bell';
import { BellSettings } from './icons/bell-settings';
import { BellStrike } from './icons/bell-strike';
import { Bike } from './icons/bike';
import { BikeRefund } from './icons/bike-refund';
import { BirthdayCake } from './icons/birthday-cake';
import { BirthdayCakeFilled } from './icons/birthday-cake-filled';
import { Bold } from './icons/bold';
import { Bolt } from './icons/bolt';
import { Book } from './icons/book';
import { InterfaceDelivery2 } from './icons/box';
import { Branch } from './icons/branch';
import { Bravo } from './icons/bravo';
import { Brewery } from './icons/brewery';
import { Briefcase } from './icons/briefcase';
import { Building } from './icons/building';
import { BuildingSettings } from './icons/building-settings';
import { BuildingUser } from './icons/building-user';
import { Bulb } from './icons/bulb';
import { BulletsList } from './icons/bullets-list';
import { Burger } from './icons/burger';
import { Calendar } from './icons/calendar';
import { CalendarCoins } from './icons/calendar-coins';
import { CalendarFilled } from './icons/calendar-filled';
import { CalendarPlus } from './icons/calendar-plus';
import { Camera } from './icons/camera';
import { Cancel } from './icons/cancel';
import { CancelCircle } from './icons/cancel-circle';
import { Car } from './icons/car';
import { Card } from './icons/card';
import { CardOrderNew } from './icons/card-order-new';
import { CardPayments } from './icons/card-payments';
import { CardPlus } from './icons/card-plus';
import { CardSettings } from './icons/card-settings';
import { CardSwitch } from './icons/card-switch';
import { CardUse } from './icons/card-use';
import { CardView } from './icons/card-view';
import { CardViewNumber } from './icons/card-view-number';
import { Cards } from './icons/cards';
import { CaretDown } from './icons/caret-down';
import { CaretLeft } from './icons/caret-left';
import { CaretRight } from './icons/caret-right';
import { CaretUp } from './icons/caret-up';
import { Cashback } from './icons/cashback';
import { CashbackAlt } from './icons/cashback-alt';
import { CashbackAlt2 } from './icons/cashback-alt2';
import { CashbackAlt3 } from './icons/cashback-alt3';
import { CashbackAlt4 } from './icons/cashback-alt4';
import { CashbackAlt5 } from './icons/cashback-alt5';
import { Chart } from './icons/chart';
import { Chat } from './icons/chat';
import { ChatJoin } from './icons/chat-join';
import { ChatPrivate } from './icons/chat-private';
import { ChatPublic } from './icons/chat-public';
import { Check } from './icons/check';
import { CheckCircle } from './icons/check-circle';
import { ChevronDown } from './icons/chevron-down';
import { ChevronDropdown } from './icons/chevron-dropdown';
import { ChevronLeft } from './icons/chevron-left';
import { ChevronRight } from './icons/chevron-right';
import { ChevronUp } from './icons/chevron-up';
import { ChopperKnife } from './icons/chopper-knife';
import { ChristmasTree } from './icons/christmas-tree';
import { CircleChart } from './icons/circle-chart';
import { Clip } from './icons/clip';
import { Clock } from './icons/clock';
import { Cloud } from './icons/cloud';
import { CloudUp } from './icons/cloud-up';
import { Concierge } from './icons/concierge';
import { Contactless } from './icons/contactless';
import { Copy } from './icons/copy';
import { CopyText } from './icons/copy-text';
import { Croissant } from './icons/croissant';
import { Crown } from './icons/crown';
import { CrownFilled } from './icons/crown-filled';
import { Cse } from './icons/cse';
import { Cursor } from './icons/cursor';
import { Custom } from './icons/custom';
import { Deals } from './icons/deals';
import { Donation } from './icons/donation';
import { DonationReceipt } from './icons/donation-receipt';
import { Dots } from './icons/dots';
import { Download } from './icons/download';
import { DownloadAlt } from './icons/download-alt';
import { Edit } from './icons/edit';
import { ElectricalRefund } from './icons/electrical-refund';
import { EmojiHeart } from './icons/emoji-heart';
import { EmojiPlus } from './icons/emoji-plus';
import { Enter } from './icons/enter';
// biome-ignore lint/suspicious/noShadowRestrictedNames: to change
import { Error } from './icons/error';
import { EuroVoucher } from './icons/euro-voucher';
import { EyeClose } from './icons/eye-close';
import { EyeOpen } from './icons/eye-open';
import { FaceID } from './icons/face-id';
import { Facebook } from './icons/facebook';
import { FastFood } from './icons/fast-food';
import { Feed } from './icons/feed';
import { File } from './icons/file';
import { Filter } from './icons/filter';
import { Flag } from './icons/flag';
import { Folder } from './icons/folder';
import { ForkKnife } from './icons/fork-knife';
import { ForkSettings } from './icons/fork-settings';
import { Freeze } from './icons/freeze';
import { Fuel } from './icons/fuel';
import { FuelRefund } from './icons/fuel-refund';
import { Furniture } from './icons/furniture';
import { Gear } from './icons/gear';
import { GenderFemale } from './icons/gender-female';
import { GenderMale } from './icons/gender-male';
import { Ghost } from './icons/ghost';
import { GhostStrike } from './icons/ghost-strike';
import { Gif } from './icons/gif';
import { Gift } from './icons/gift';
import { GiftCard } from './icons/gift-card';
import { GiftRewind } from './icons/gift-rewind';
import { Giveback } from './icons/giveback';
import { GooglePay } from './icons/google-pay';
import { Grocery } from './icons/grocery';
import { Group } from './icons/group';
import { Hash } from './icons/hash';
import { Heading1 } from './icons/heading1';
import { Heading2 } from './icons/heading2';
import { Heart } from './icons/heart';
import { HeartAlt } from './icons/heart-alt';
import { Heartbeat } from './icons/heartbeat';
import { Help } from './icons/help';
import { HideKeyboard } from './icons/hide-keyboard';
import { HideWallet } from './icons/hide-wallet';
import { Home } from './icons/home';
import { Hotels } from './icons/hotels';
import { Hourglass } from './icons/hourglass';
import { Image } from './icons/image';
import { Incognito } from './icons/incognito';
import { Information } from './icons/information';
import { Instagram } from './icons/instagram';
import { Internet } from './icons/internet';
import { Iphone } from './icons/iphone';
import { Italic } from './icons/italic';
import { Key } from './icons/key';
import { Leaf } from './icons/leaf';
import { LifeBuoy } from './icons/life-buoy';
import { LineView } from './icons/line-view';
import { Link } from './icons/link';
import { LinkCard } from './icons/link-card';
import { Lips } from './icons/lips';
import { ListReorder } from './icons/list-reorder';
import { Loading } from './icons/loading';
import { Lock } from './icons/lock';
import { LogOut } from './icons/log-out';
import { Mail } from './icons/mail';
import { MarkerPin } from './icons/marker-pin';
import { MarkerPinFilled } from './icons/marker-pin-filled';
import { MarkerPinPlus } from './icons/marker-pin-plus';
import { Mention } from './icons/mention';
import { Mic } from './icons/mic';
import { Microphone } from './icons/microphone';
import { Minus } from './icons/minus';
import { MobilityFeesRefund } from './icons/mobility-fees-refund';
import { MobilityRefund } from './icons/mobility-refund';
import { Moon } from './icons/moon';
import { Movie } from './icons/movie';
import { MovieCamera } from './icons/movie-camera';
import { MovieCameraFilled } from './icons/movie-camera-filled';
import { PaperMap } from './icons/paper-map';
import { Password } from './icons/password';
import { Pause } from './icons/pause';
import { PaymentDevice } from './icons/payment-device';
import { Phone } from './icons/phone';
import { PinCode } from './icons/pin-code';
import { Pizza } from './icons/pizza';
import { Planet } from './icons/planet';
import { Plans } from './icons/plans';
import { PlansFilled } from './icons/plans-filled';
import { Play } from './icons/play';
import { Plus } from './icons/plus';
import { PlusCircle } from './icons/plus-circle';
import { PrivacyPolicy } from './icons/privacy-policy';
import { QrCode } from './icons/qr-code';
import { QuestionMark } from './icons/question-mark';
import { QuestionMarkInBox } from './icons/question-mark-in-box';
import { Quote } from './icons/quote';
import { Receipt } from './icons/receipt';
import { Recurring } from './icons/recurring';
import { RecurringClock } from './icons/recurring-clock';
import { RecurringTransfer } from './icons/recurring-transfer';
import { Refund } from './icons/refund';
import { Replay } from './icons/replay';
import { Reply } from './icons/reply';
import { Rings } from './icons/rings';
import { Route } from './icons/route';
import { Safe } from './icons/safe';
import { Scan } from './icons/scan';
import { Schedule } from './icons/schedule';
import { School } from './icons/school';
import { Scooter } from './icons/scooter';
import { Search } from './icons/search';
import { Send } from './icons/send';
import { Services } from './icons/services';
import { Settings } from './icons/settings';
import { Share } from './icons/share';
import { Shield } from './icons/shield';
import { ShoppingBag } from './icons/shopping-bag';
import { Shortcuts } from './icons/shortcuts';
import { Smiley } from './icons/smiley';
import { SmileyAlt } from './icons/smiley-alt';
import { Snooze } from './icons/snooze';
import { SpareChange } from './icons/spare-change';
import { Sparkles } from './icons/sparkles';
import { Speaker } from './icons/speaker';
import { Split } from './icons/split';
import { Sports } from './icons/sports';
import { Star } from './icons/star';
import { StarFilled } from './icons/star-filled';
import { StarHalf } from './icons/star-half';
import { Status } from './icons/status';
import { Strikethrough } from './icons/strikethrough';
import { Subway } from './icons/subway';
import { Supermarket } from './icons/supermarket';
import { Survey } from './icons/survey';
import { Sushi } from './icons/sushi';
import { Swile } from './icons/swile';
import { Switch } from './icons/switch-icon';
import { Table } from './icons/table';
import { Tada } from './icons/tada';
import { Tag } from './icons/tag';
import { Target } from './icons/target';
import { Team } from './icons/team';
import { TeamFilled } from './icons/team-filled';
import { TeamPlus } from './icons/team-plus';
import { Tech } from './icons/tech';
import { Threads } from './icons/threads';
import { Ticket } from './icons/ticket';
import { TouchID } from './icons/touch-id';
import { TransportRefund } from './icons/transport-refund';
import { Trash } from './icons/trash';
import { Travel } from './icons/travel';
import { Truck } from './icons/truck';
import { Twitter } from './icons/twitter';
import { Typography } from './icons/typography';
import { TypographySize } from './icons/typography-size';
import { Underline } from './icons/underline';
import { Unlock } from './icons/unlock';
import { Unread } from './icons/unread';
import { Update } from './icons/update';
import { User } from './icons/user';
import { UserArrowRight } from './icons/user-arrow-right';
import { UserCard } from './icons/user-card';
import { UserCheck } from './icons/user-check';
import { UserCross } from './icons/user-cross';
import { UserGear } from './icons/user-gear';
import { UserPlus } from './icons/user-plus';
import { Video } from './icons/video';
import { Voucher } from './icons/voucher';
import { Walk } from './icons/walk';
import { WalkFilled } from './icons/walk-filled';
import { Wallet } from './icons/wallet';
import { Warning } from './icons/warning';
import { WarningAlt } from './icons/warning-alt';
import { WirelessPayments } from './icons/wireless-payments';
import { Write } from './icons/write';
export const Icons = {
    bulb: Bulb,
    book: Book,
    furniture: Furniture,
    animals: Animals,
    sports: Sports,
    hotels: Hotels,
    hourglass: Hourglass,
    'shopping-bag': ShoppingBag,
    internet: Internet,
    tech: Tech,
    ticket: Ticket,
    bank: Bank,
    supermarket: Supermarket,
    'apple-pay': ApplePay,
    building: Building,
    briefcase: Briefcase,
    card: Card,
    cards: Cards,
    'card-switch': CardSwitch,
    'card-view-number': CardViewNumber,
    'gift-card': GiftCard,
    'card-payments': CardPayments,
    'card-use': CardUse,
    'cashback-alt': CashbackAlt,
    cashback: Cashback,
    contactless: Contactless,
    chart: Chart,
    donation: Donation,
    deals: Deals,
    giveback: Giveback,
    'recurring-transfer': RecurringTransfer,
    'donation-receipt': DonationReceipt,
    'google-pay': GooglePay,
    receipt: Receipt,
    'pin-code': PinCode,
    refund: Refund,
    'spare-change': SpareChange,
    safe: Safe,
    wallet: Wallet,
    split: Split,
    'circle-chart': CircleChart,
    voucher: Voucher,
    'euro-voucher': EuroVoucher,
    'birthday-cake-filled': BirthdayCakeFilled,
    burger: Burger,
    brewery: Brewery,
    'birthday-cake': BirthdayCake,
    'chopper-knife': ChopperKnife,
    'fast-food': FastFood,
    'fork-knife': ForkKnife,
    croissant: Croissant,
    grocery: Grocery,
    pizza: Pizza,
    sushi: Sushi,
    search: Search,
    gear: Gear,
    plus: Plus,
    minus: Minus,
    check: Check,
    'chevron-right': ChevronRight,
    'chevron-left': ChevronLeft,
    'chevron-down': ChevronDown,
    'chevron-up': ChevronUp,
    'fork-settings': ForkSettings,
    archive: Archive,
    'building-settings': BuildingSettings,
    'arrow-left': ArrowLeft,
    'arrow-down': ArrowDown,
    'arrow-minimize': ArrowMinimize,
    'arrow-right': ArrowRight,
    'arrow-extend': ArrowExtend,
    'arrow-up': ArrowUp,
    'bell-strike': BellStrike,
    'arrow-shuffle': ArrowShuffle,
    bell: Bell,
    barcode: Barcode,
    bravo: Bravo,
    cancel: Cancel,
    'cancel-circle': CancelCircle,
    bolt: Bolt,
    'card-settings': CardSettings,
    gift: Gift,
    'caret-down': CaretDown,
    'caret-left': CaretLeft,
    'caret-right': CaretRight,
    'caret-up': CaretUp,
    'chevron-dropdown': ChevronDropdown,
    cloud: Cloud,
    'check-circle': CheckCircle,
    'copy-text': CopyText,
    clip: Clip,
    copy: Copy,
    cursor: Cursor,
    concierge: Concierge,
    cse: Cse,
    box: InterfaceDelivery2,
    dots: Dots,
    truck: Truck,
    'bullets-list': BulletsList,
    bold: Bold,
    heading1: Heading1,
    heading2: Heading2,
    italic: Italic,
    quote: Quote,
    strikethrough: Strikethrough,
    table: Table,
    typography: Typography,
    'typography-size': TypographySize,
    underline: Underline,
    'heart-alt': HeartAlt,
    download: Download,
    edit: Edit,
    error: Error,
    'emoji-plus': EmojiPlus,
    'emoji-heart': EmojiHeart,
    enter: Enter,
    'eye-open': EyeOpen,
    feed: Feed,
    file: File,
    tag: Tag,
    filter: Filter,
    'face-id': FaceID,
    flag: Flag,
    heartbeat: Heartbeat,
    activity: Activity,
    folder: Folder,
    'eye-close': EyeClose,
    heart: Heart,
    'bag-with-gift': BagWithGift,
    'hide-keyboard': HideKeyboard,
    image: Image,
    incognito: Incognito,
    home: Home,
    information: Information,
    'link-card': LinkCard,
    'life-buoy': LifeBuoy,
    'list-reorder': ListReorder,
    link: Link,
    loading: Loading,
    'log-out': LogOut,
    mail: Mail,
    lock: Lock,
    microphone: Microphone,
    password: Password,
    phone: Phone,
    rings: Rings,
    crown: Crown,
    camera: Camera,
    'plus-superellipse': PlusCircle,
    'plus-circle': PlusCircle,
    play: Play,
    planet: Planet,
    'question-mark': QuestionMark,
    shortcuts: Shortcuts,
    'question-mark-in-box': QuestionMarkInBox,
    survey: Survey,
    scan: Scan,
    shield: Shield,
    'privacy-policy': PrivacyPolicy,
    services: Services,
    settings: Settings,
    share: Share,
    'smiley-alt': SmileyAlt,
    smiley: Smiley,
    sparkles: Sparkles,
    'star-half': StarHalf,
    star: Star,
    status: Status,
    switch: Switch,
    swile: Swile,
    'touch-id': TouchID,
    trash: Trash,
    unlock: Unlock,
    'cloud-up': CloudUp,
    update: Update,
    'movie-camera-filled': MovieCameraFilled,
    video: Video,
    abcd: Abcd,
    warning: Warning,
    movie: Movie,
    car: Car,
    'marker-pin-filled': MarkerPinFilled,
    'marker-pin-plus': MarkerPinPlus,
    'plans-filled': PlansFilled,
    'marker-pin': MarkerPin,
    'paper-map': PaperMap,
    plans: Plans,
    route: Route,
    subway: Subway,
    target: Target,
    travel: Travel,
    'walk-filled': WalkFilled,
    bike: Bike,
    walk: Walk,
    'chat-private': ChatPrivate,
    chat: Chat,
    'chat-join': ChatJoin,
    'chat-public': ChatPublic,
    gif: Gif,
    hash: Hash,
    help: Help,
    send: Send,
    reply: Reply,
    mention: Mention,
    threads: Threads,
    unread: Unread,
    write: Write,
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    clock: Clock,
    'calendar-plus': CalendarPlus,
    'calendar-filled': CalendarFilled,
    calendar: Calendar,
    'calendar-coins': CalendarCoins,
    replay: Replay,
    'recurring-clock': RecurringClock,
    recurring: Recurring,
    snooze: Snooze,
    schedule: Schedule,
    user: User,
    'user-card': UserCard,
    'user-arrow-right': UserArrowRight,
    'user-gear': UserGear,
    'team-filled': TeamFilled,
    'user-cross': UserCross,
    'user-plus': UserPlus,
    team: Team,
    'user-check': UserCheck,
    lips: Lips,
    mic: Mic,
    'arrow-up-down': ArrowUpDown,
    'card-order-new': CardOrderNew,
    school: School,
    'cashback-alt3': CashbackAlt3,
    'card-plus': CardPlus,
    'cashback-alt4': CashbackAlt4,
    'cashback-alt5': CashbackAlt5,
    'cashback-alt2': CashbackAlt2,
    freeze: Freeze,
    'wireless-payments': WirelessPayments,
    key: Key,
    'hide-wallet': HideWallet,
    'assistance-services': AssistanceServices,
    'mobility-refund': MobilityRefund,
    leaf: Leaf,
    'building-user': BuildingUser,
    'payment-device': PaymentDevice,
    'bell-settings': BellSettings,
    'crown-filled': CrownFilled,
    'download-alt': DownloadAlt,
    custom: Custom,
    'card-view': CardView,
    iphone: Iphone,
    'line-view': LineView,
    moon: Moon,
    'gift-rewind': GiftRewind,
    speaker: Speaker,
    'star-filled': StarFilled,
    'warning-alt': WarningAlt,
    'movie-camera': MovieCamera,
    tada: Tada,
    pause: Pause,
    'qr-code': QrCode,
    'gender-female': GenderFemale,
    ghost: Ghost,
    'ghost-strike': GhostStrike,
    'gender-male': GenderMale,
    'team-plus': TeamPlus,
    fuel: Fuel,
    group: Group,
    scooter: Scooter,
    branch: Branch,
    baby: Baby,
    'christmas-tree': ChristmasTree,
    'bike-refund': BikeRefund,
    'electrical-refund': ElectricalRefund,
    'mobility-fees-refund': MobilityFeesRefund,
    'transport-refund': TransportRefund,
    'fuel-refund': FuelRefund,
    'beach-umbrella': BeachUmbrella,
};
export const FillIcons = [
    'apple-pay',
    'beach-umbrella',
    'birthday-cake-filled',
    'bold',
    'calendar-filled',
    'cancel-circle',
    'caret-down',
    'caret-left',
    'caret-right',
    'caret-up',
    'cashback-alt2',
    'check-circle',
    'crown-filled',
    'dots',
    'google-pay',
    'heading1',
    'heading2',
    'italic',
    'marker-pin-filled',
    'movie-camera-filled',
    'plans-filled',
    'quote',
    'rings',
    'safe',
    'star-filled',
    'star-half',
    'strikethrough',
    'team-filled',
    'typography',
    'typography-size',
    'underline',
    'walk-filled',
];
